/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const detailsLabelMap = {
  label_deal_bundle_add_to_cart: 'label_deal_bundle_add_to_cart',
  label_deal_bundle_qualifying_item: 'label_deal_bundle_qualifying_item',
  label_deal_bundle_complete_your_deal: 'label_deal_bundle_complete_your_deal',
  label_deal_bundle_complete_your_deal_description:
    'label_deal_bundle_complete_your_deal_description',
  label_deal_bundle_current_vehicle_title: 'label_deal_bundle_current_vehicle_title',
  label_deal_bundle_constraint_item_swap: 'label_deal_bundle_constraint_item_swap',
  lblDealOverview: 'lbl_deals_drawer_deal_overview',
  lblDealsTotal: 'lbl_deals_total',
  lblTitleDetail: 'lbl_deals_detail_title',
};
